export default __webpack_public_path__ + "static/media/Create-documentation.2af1234a.md";